import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-card-savings" }
const _hoisted_2 = { class: "product-card-savings__content" }
const _hoisted_3 = { class: "cost-container" }
const _hoisted_4 = { class: "cost-item" }
const _hoisted_5 = { class: "cost-label" }
const _hoisted_6 = { class: "cost-item" }
const _hoisted_7 = {
  key: 0,
  class: "cost-value"
}
const _hoisted_8 = { class: "cost-item" }
const _hoisted_9 = { class: "cost-value" }
const _hoisted_10 = { class: "cost-item" }
const _hoisted_11 = { class: "cost-value" }

import { computed, PropType } from 'vue';
import { Product } from '@/classes';
import { formatNumber } from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'Savings',
  props: {
  product: { type: Object as PropType<Product>, required: true },
},
  setup(__props) {

const props = __props;

const priceYearly = computed(() => {
  if (props.product?.attributes.details.contractDetails.savingCalculation === 'beforeBonus') {
    return props.product.price?.mapped.active.yearlyGross;
  }

  return props.product.price?.mapped.active.yearlyWithBonusGross;
});

const hasSavings = computed(() => {
  if (props.product?.attributes.details.contractDetails.savingCalculation === 'beforeBonus') {
    return props.product.price?.mapped.active.savingsYearlyGross > 0;
  }

  return props.product.price?.mapped.active.yearlyWithBonusGross > 0;
});

const priceBaseSupplier = computed(() => {
  if (hasSavings.value) {
    return props.product.price?.baseSupplier?.yearlyGross
        || (props.product.price?.baseSupplier?.yearly ?? 0) * 1.19;
  }

  return undefined;
});

const savingsValue = computed(() => {
  if (props.product?.attributes.details.contractDetails.savingCalculation === 'beforeBonus') {
    return formatNumber(props.product.price?.mapped.active.savingsYearlyGross, 2);
  }

  return formatNumber(props.product.price?.mapped.active.savingsYearlyWithBonusGross, 2);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "title" }, "Information zur Ersparnisberechnung", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "cost-item" }, [
          _createElementVNode("div", { class: "cost-label" }, [
            _createElementVNode("b", null, "Grundversorger")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(props.product.price?.baseSupplier?.supplierName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "cost-label" }, "Kosten", -1)),
          (priceBaseSupplier.value !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(formatNumber)(priceBaseSupplier.value, 2)) + " € / Jahr ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "cost-label" }, "− Kosten Bodensee Energie", -1)),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatNumber)(priceYearly.value, 2)) + " € / Jahr ", 1)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "color-primary" }, null, -1)),
        _createElementVNode("div", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "cost-label" }, [
            _createElementVNode("b", null, "= Ersparnis")
          ], -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("b", null, _toDisplayString(savingsValue.value) + " €", 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})